import axios from '../../store/api';
export const APP_KEY = 'projectbase_pm_v1';
export const pmApi = {
  command: (tool, args = {}) => axios.post(`/config/projectbase/commands/${tool}`, args, {
    timeout: 25000
  }).then(r => r.data)
};
export const labels = {
  project: 'Proyectos',
  activity: 'Actividades',
  session: 'Sesiones',
  task: 'Tareas',
  resource: 'Recursos',
  allocation: 'Asignaciones',
  participant: 'Participantes',
  attendance: 'Asistencia',
  result: 'Resultados',
  risk: 'Riesgos'
};
export const valueLabels = {
  planned: 'Planificado',
  active: 'En ejecución',
  completed: 'Completado',
  paused: 'Pausado',
  pending: 'Pendiente',
  doing: 'En curso',
  cancelled: 'Cancelado',
  course: 'Curso',
  workshop: 'Taller',
  essential: 'Esencial',
  high: 'Alta',
  normal: 'Normal',
  optional: 'Opcional',
  person: 'Persona',
  room: 'Espacio',
  equipment: 'Equipo',
  material: 'Material',
  money: 'Dinero',
  hours: 'Horas por semana',
  units: 'Unidades',
  open: 'Abierto',
  mitigated: 'Mitigado',
  closed: 'Cerrado',
  low: 'Baja',
  medium: 'Media',
  ready: 'Listo',
  review: 'En revisión',
  learning: 'Aprendizaje',
  application: 'Aplicación',
  outcome: 'Resultado externo',
  deliverable: 'Entregable',
  milestone: 'Hito'
};
// Explicit field metadata keeps web editing aligned with the typed server commands.
export const fields = {
  project: [['objective', 'Resultado esperado', 'text'], ['startDate', 'Inicio', 'date'], ['endDate', 'Cierre', 'date'], ['budget', 'Presupuesto', 'number'], ['wipLimit', 'Límite de tareas en curso (ajustable)', 'number'], ['currency', 'Moneda', ['BOB', 'USD']], ['status', 'Estado', ['planned', 'active', 'completed', 'paused']]],
  activity: [['type', 'Tipo', ['course', 'workshop', 'deliverable', 'milestone']], ['outcome', 'Qué podrá hacer el participante', 'text'], ['capacity', 'Cupos', 'number'], ['target', 'Meta de logros', 'number'], ['cost', 'Costo base (sin recursos)', 'number'], ['costConfirmed', 'Costo base confirmado (incluido si es cero)', 'boolean'], ['actualBaseCost', 'Costo base real (si se conoce)', 'nullableNumber'], ['actualCostOn', 'Fecha del costo real', 'nullableDate'], ['priority', 'Prioridad', ['essential', 'high', 'normal', 'optional']], ['protected', 'Compromiso que debemos proteger', 'boolean'], ['dependencies', 'Actividades previas', 'activity[]'], ['status', 'Estado', ['planned', 'active', 'completed', 'paused']]],
  session: [['activityId', 'Actividad', 'activity'], ['date', 'Fecha', 'date'], ['startTime', 'Desde', 'time'], ['endTime', 'Hasta', 'time'], ['actualDate', 'Fecha real de ejecución', 'nullableDate'], ['actualStartTime', 'Inicio real', 'nullableTime'], ['actualEndTime', 'Fin real', 'nullableTime'], ['location', 'Lugar', 'text'], ['facilitator', 'Facilitador', 'text'], ['status', 'Estado', ['planned', 'completed', 'cancelled']]],
  resource: [['type', 'Tipo', ['person', 'room', 'equipment', 'material', 'money']], ['unit', 'Unidad', ['hours', 'units', 'BOB', 'USD']], ['capacity', 'Disponibilidad', 'number'], ['costPerUnit', 'Costo por unidad', 'number'], ['costConfirmed', 'Costo unitario confirmado (incluido si es cero)', 'boolean'], ['skills', 'Habilidades o características', 'text']],
  allocation: [['sessionId', 'Sesión', 'session'], ['resourceId', 'Recurso', 'resource'], ['planned', 'Cantidad prevista', 'number'], ['actual', 'Uso real (vacío si no se registró)', 'nullableNumber'], ['actualCost', 'Costo real de esta asignación', 'nullableNumber']],
  participant: [['activityIds', 'Inscripciones', 'activity[]']],
  attendance: [['sessionId', 'Sesión', 'session'], ['participantId', 'Participante', 'participant'], ['present', 'Asistió', 'boolean']],
  result: [['activityId', 'Actividad', 'activity'], ['participantId', 'Participante', 'participant'], ['stage', 'Qué estamos comprobando', ['learning', 'application', 'outcome']], ['achieved', 'Logro comprobado', 'boolean'], ['evidence', 'Evidencia del resultado', 'text'], ['observedOn', 'Fecha de evaluación', 'date']],
  task: [['activityId', 'Actividad (opcional)', 'activity?'], ['responsible', 'Responsable', 'text'], ['dueDate', 'Fecha límite', 'date'], ['acceptance', 'Cuándo consideraremos terminada la tarea', 'text'], ['completionEvidence', 'Evidencia de finalización', 'text'], ['blockedReason', 'Motivo del bloqueo (vacío si no hay)', 'text'], ['startedOn', 'Inicio real del trabajo', 'nullableDate'], ['finishedOn', 'Finalización real', 'nullableDate'], ['status', 'Estado', ['pending', 'ready', 'doing', 'review', 'completed', 'cancelled']]],
  risk: [['probability', 'Probabilidad', ['low', 'medium', 'high']], ['impact', 'Impacto', ['low', 'medium', 'high']], ['mitigation', 'Cómo responderemos', 'text'], ['responsible', 'Responsable', 'text'], ['status', 'Estado', ['open', 'mitigated', 'closed']]]
};
export function initialRecord(kind, projectId, record) {
  const value = {
    name: '',
    notes: '',
    ...(kind !== 'project' ? {
      projectId
    } : {})
  };
  for (const [key,, type] of fields[kind]) value[key] = record?.[key] ?? (Array.isArray(type) ? type[0] : type === 'boolean' ? false : type.endsWith('[]') ? [] : type.startsWith('nullable') || type.endsWith('?') ? null : type === 'number' ? 0 : '');
  if (kind === 'project' && !record?.wipLimit) value.wipLimit = 3;
  return {
    ...value,
    ...Object.fromEntries(['name', 'notes', 'projectId'].filter(k => record?.[k] !== undefined).map(k => [k, record[k]]))
  };
}
